import {
    ECommerceActionHandlers,
    ECommerce as ECommerceBase,
    ECommerceProps
} from "@omni/components/components/Product/ECommerce/eCommerce";
import { EcommerceDefault } from "@omni/components/components/Product/ECommerce/eCommerce.default";

export type ECommerceContainerProps = Omit<ECommerceProps, "handlers">;

const ECommerceContainer = ({
    product,
    tooltips,
    infoLink,
    cashbackPagePath,
    contextAwareXfPath,
    paintConfiguratorPath
}: ECommerceContainerProps) => {
    return (
        <ECommerceBase
            product={product}
            tooltips={tooltips}
            infoLink={infoLink}
            cashbackPagePath={cashbackPagePath}
            contextAwareXfPath={contextAwareXfPath}
            paintConfiguratorPath={paintConfiguratorPath}
            handlers={ECommerceActionHandlers}
        >
            <ECommerceBase.Providers>
                <EcommerceDefault />
            </ECommerceBase.Providers>
        </ECommerceBase>
    );
};

export { ECommerceContainer };
